import React, { useEffect, useState } from "react";
import SpinWheelService from "../../Services/SpinWheelService";
import { useNavigate } from "react-router-dom";

const Gift = ({giftsDetail}) => {
  const userObj = JSON.parse(localStorage.getItem("userData"));


  function generateUniqueRandomNumbers(count, min, max) {
    const uniqueNumbers = new Set();

    while (uniqueNumbers.size < count) {
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      uniqueNumbers.add(randomNumber);
    }

    return Array.from(uniqueNumbers);
  }



  const [gifts, setGifts] = useState([
    { id: 1, name: "", odds: "", isOn: false, file: null },
    { id: 2, name: "", odds: "", isOn: false, file: null},
    { id: 3, name: "", odds: "", isOn: false, file: null },
    { id: 4, name: "", odds: "", isOn: false, file: null },
    { id: 5, name: "", odds: "", isOn: false, file: null },
    { id: 6, name: "", odds: "", isOn: false, file: null },
  ]);

  console.log(gifts);

  const handleToggle = (id) => {
    setGifts((prevGifts) =>
      prevGifts.map((gift) =>
        gift.id === id ? { ...gift, isOn: !gift.isOn } : gift
      )
    );
  };



  const handleInputChange = (id, field, value) => {
    setGifts((prevGifts) =>
      prevGifts.map((gift) => {
        if (gift.id === id) {
          let updatedValue = value;
          if (field === "odds") {
            updatedValue = Math.min(Number(value.replace(/\D/g, "")), 1000);
          }
          return { ...gift, [field]: updatedValue };
        }
        return gift;
      })
    );
  };



  const handleGiftImageUpload = async (id, file) => {
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      const bannerFolder = "spinWheelGiftImages";
      const response = await SpinWheelService.createBannerImageTemplate(
        formData,
        bannerFolder
      );
      const imageUrl = response.data.imageUrl;
      setGifts((prevGifts) =>
        prevGifts.map((gift) =>
          gift.id === id ? { ...gift, file: imageUrl } : gift
        )
      );
    } catch (error) {
      console.error("Error uploading file:", error);
      // Optionally show an error toast
      // showErrorToast("Failed to upload file. Please try again.");
    }
  };

  const validateAndFormatGifts = () => {
    const isValid = gifts.every(
      (gift) => gift.name && gift.odds && gift.file && gift.id
    );

    if (isValid) {
      let index=-1;
let oddsSum = 0;
      gifts.map((gift) => {
        if(gift.isOn){
oddsSum = oddsSum + parseInt(gift?.odds)
        }
      });
      const randomNumbers = generateUniqueRandomNumbers(oddsSum, 1, 1000);
      let oddsCounter = 0;
      const formattedData = gifts.map((gift) => {
if(gift.isOn){
  index=index+1;
  let obj = {
    order: gift.id,
    giftName: gift.name,
    odds: parseInt(gift.odds),
    giftImageUrl: gift.file,
    resultType: gift.isOn,
    giftNumber:  randomNumbers.slice(oddsCounter, parseInt(gift.odds)+oddsCounter)
  }

  oddsCounter = oddsCounter+ parseInt(gift.odds);

  return obj;

}else{
  return {
    order: gift.id,
    giftName: gift.name,
    odds: parseInt(gift.odds),
    giftImageUrl: gift.file,
    resultType: gift.isOn,
    giftNumber: [0]
  }
}

    });

      console.log("Formatted Gifts Data:", formattedData);
      giftsDetail(formattedData)

      // if (userRole === "Admin") {
      //   navigate(`/admin/spin-wheel-creation`, { state: { gifts:formattedData } });
      // } else if (userRole === "CMO") {
      //   navigate(`/cmo/spin-wheel-creation`, { state: { gifts:formattedData } });
      // }
    }
  };

  useEffect(() => {
    validateAndFormatGifts();
  }, [gifts]);
  return (
    <div>
      <table className="w-full ">
        <thead>
          <tr className="text-customGreen text-xl  ">
            <th></th>
            <th>Name</th>
            <th>Image</th>
            <th>Odds</th>
            <th>Type</th>
          </tr>
        </thead>
        {gifts.map((gift) => (
          <tbody className=" ">
            <tr className="" key={gift.id}>
              <td className="w-fit  text-lg font-bold pt-8">Gift {gift.id}</td>
              <td className="w-52 px-4  pt-8">
                <input
                  type="text"
                  value={gift.name}
                  onChange={(e) =>
                    handleInputChange(gift.id, "name", e.target.value)
                  }
                  className="w-full h-16 border border-gray-300 bg-appGrayBackground rounded-lg focus:outline-none"
                />
              </td>
              <td className="w-52 px-4 pt-8">
                <input
                  id={`fileInput-${gift.id}`}
                  type="file"
                  className="hidden"
            accept=".jpeg, .jpg, .png, .webp, .svg"

                  onChange={(e) =>
                    handleGiftImageUpload(gift.id, e.target.files[0])
                  }
                />
                <label
                  htmlFor={`fileInput-${gift.id}`}
                  className="w-full h-16 flex items-center justify-center border border-gray-300 bg-appGrayBackground rounded-lg cursor-pointer"
                >
    {gift.file ? (
      <img
        src={gift.file}
        alt="Preview"
        className="w-full h-full object-fit rounded-lg"
      />
    ) : (
      "Click here to upload"
    )}
                </label>
              </td>

              <td className="w-40 h-16 mt-8 flex items-center border border-gray-300 rounded-lg bg-appGrayBackground px-4">
                <input
                  type="text"
                  value={gift.odds}
                  onChange={(e) =>
                    handleInputChange(gift.id, "odds", e.target.value)
                  }
                  className="flex-1 bg-transparent outline-none w-10"
                  placeholder=""
                />
                <div className="border-l border-gray-400 h-full ml-4 pl-4 flex items-center justify-center text-gray-600">
                  <div className="text-center">
                    <div>In</div>
                    <div className="font-bold text-lg">1000</div>
                  </div>
                </div>
              </td>
              <td className="pt-8">
                <div className="flex justify-around">
                  <span>Lose</span>
                  <button
                    onClick={() => handleToggle(gift.id)}
                    className={`w-16 h-8 flex items-center rounded-full p-1 transition-colors ${
                      gift.isOn ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    <div
                      className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
                        gift.isOn ? "translate-x-8" : "translate-x-0"
                      }`}
                    ></div>
                  </button>
                  <span>Win</span>
                </div>
              </td>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
  );
};

export default Gift;
